<template>
  <section class="appointAccordDiv">
    <viewTitle
      title="业务管理 / 车辆预约管理 / 预约记录管理"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-radio-group
          v-model="params.radioTime"
          @change="radioChange"
          size="small"
          fill="#3389f1"
          style="vertical-align: bottom;margin-right: 15px;"
        >
          <el-radio-button label="昨天"></el-radio-button>
          <el-radio-button label="今天"></el-radio-button>
          <el-radio-button label="明天"></el-radio-button>
        </el-radio-group>
        <!-- <el-date-picker
          v-model="params.time"
          type="date"
          placeholder="选择其它时间"
        >
        </el-date-picker> -->
        <el-date-picker
          v-model="params.time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="changeTimeRange"
        >
        </el-date-picker>
        <!-- </div> -->
        <!-- </section> -->
        <!-- 按钮组2 -->
        <!-- <section class="controler"> -->
        <!-- <div class="ctrLeft" style="width: 100%;"> -->
        <span class="rectl">状态: </span>
        <el-select
          class="ctl"
          clearable
          v-model="params.state"
          placeholder="请选择状态"
          label="状态"
          @change="changeState"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in stateOption"
            :key="index"
          ></el-option>
        </el-select>
        <el-input
          class="ctl rectl"
          style="width: 20% !important;"
          clearable
          placeholder="输入关键字搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
        >
          刷新数据
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="日期" width="170px">
          <template slot-scope="scope">
            {{ formatTime(scope.row.booking_day) }}
          </template>
        </el-table-column>
        <el-table-column label="运输单位">
          <template slot-scope="scope">
            {{ scope.row.unit || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="车牌号">
          <template slot-scope="scope">
            {{ scope.row.license_plate || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="司机姓名">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="手机号码">
          <template slot-scope="scope">
            {{ scope.row.contact || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span :style="`color: ${stateColor[scope.row.booking_state]}`">
              {{ stateOption[scope.row.booking_state] || "--" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >查看详情</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import keepAliveMinxin from "@/mixins/rh/keepAliveMinxin.js";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      params: {
        keyword: "", // 关键字搜索
        state: 0, // 状态
        radioTime: "今天", // radio默认选择的时间
        radioTimeValue: "",
        time: "", // timepicker时间
        begin_time: "",
        end_time: ""
      },
      maxSize: 0,
      tableData: [], // 表格数据
      stateOption: [
        "全部",
        "未报到",
        "已报到",
        "报到失效",
        "办理中",
        "已挂起",
        "已失效",
        "已关闭",
        "已完成"
        // "已拒绝"
      ],
      stateColor: [
        "",
        "#B08931",
        "#00C8D2",
        "#666666",
        "#4F86F6",
        "#F5A623",
        "#666666",
        "#EC3F67",
        "#008B5E"
        // "#EC3F67"
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      toKeepAlivePath: "/rhqy/service/appoint/accordList/truckDetail" // 当前路由访问某个页面时的不清除缓存
    };
  },

  components: {
    pagi,
    viewTitle
  },

  mixins: [mixinTableLyout, keepAliveMinxin],

  computed: {
    // isOverSize() {
    //   return this.tableData.length > 0;
    // }
  },

  mounted() {
    // setTimeout(() => {
    //   this.resizeTableHeight();
    //   window.addEventListener(
    //     "resize",
    //     e => {
    //       //  初始化表格合适高度
    //       this.resizeTableHeight();
    //       console.log(e);
    //     },
    //     false
    //   );
    // }, 500);
    this.params.begin_time = moment()
      .startOf("day")
      .format("YYYYMMDD");
    this.params.end_time = moment()
      .startOf("day")
      .format("YYYYMMDD");
    // this.getList();
  },

  async activated() {
    this.getList();
  },

  created() {},

  methods: {
    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 选择时间范围
    changeTimeRange() {
      if (this.params.time === null) {
        this.params.begin_time = "";
        this.params.end_time = "";
        this.params.time = [];
        this.params.radioTime = "今天";
        this.params.begin_time = moment()
          .startOf("day")
          .format("YYYYMMDD");
        this.params.end_time = moment()
          .startOf("day")
          .format("YYYYMMDD");
      } else {
        this.params.radioTime = "";
        this.params.begin_time = moment(this.params.time[0]).format("YYYYMMDD");
        this.params.end_time = moment(this.params.time[1]).format("YYYYMMDD");
      }
      this.page = 1;
      this.getList();
    },

    // 格式化时间
    formatTime(str) {
      console.log(str);
      let str1 = String(str);
      let date = `${str1.substring(0, 4)}-${str1.substring(
        4,
        6
      )}-${str1.substring(6, 8)}`;
      let day = "";
      switch (moment(date).day()) {
        case 1:
          day = "周一";
          break;
        case 2:
          day = "周二";
          break;
        case 3:
          day = "周三";
          break;
        case 4:
          day = "周四";
          break;
        case 5:
          day = "周五";
          break;
        case 6:
          day = "周六";
          break;
        case 0:
          day = "周日";
          break;
      }
      let colYear = Number(str1.substring(0, 4));
      if (moment().year() === colYear) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日(${day})`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日(${day})`;
      }
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_booking_record",
        data: {
          booking_day: "",
          begin_time: this.params.begin_time,
          end_time: this.params.end_time,
          keyword: this.params.keyword,
          booking_state: this.params.state,
          report_state: "",
          page: this.page,
          page_size: this.pageSize
        }
      });
      console.log("列表");
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 修改状态
    changeState() {
      this.page = 1;
      this.getList();
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    },

    // 点击radio(切换时间)
    radioChange(val) {
      console.log(val);
      this.params.time = [];
      switch (val) {
        case "昨天":
          this.params.begin_time = moment()
            .subtract(1, "days")
            .format("YYYYMMDD");
          this.params.end_time = moment()
            .subtract(1, "days")
            .format("YYYYMMDD");
          break;
        case "今天":
          this.params.begin_time = moment()
            .startOf("day")
            .format("YYYYMMDD");
          this.params.end_time = moment()
            .startOf("day")
            .format("YYYYMMDD");
          break;
        case "明天":
          this.params.begin_time = moment()
            .add(1, "days")
            .format("YYYYMMDD");
          this.params.end_time = moment()
            .add(1, "days")
            .format("YYYYMMDD");
          break;
        default:
          break;
      }
      this.getList();
    },

    // 查看详情
    viewDetail(row) {
      this.$router.push({
        path: "/rhqy/service/appoint/accordList/truckDetail",
        query: {
          type: "appoint",
          id: row.booking_info_id,
          booking_id: row.booking_id
        }
      });
    }

    // 重置高度
    // resizeTableHeight() {
    //   const BANNER_HEIGHT = 25; // 头部导航高度
    //   const PADDING = 24; // padding
    //   const ETC = 260; // 头部 和 底部导航高度
    //   var offsetHeihgt = window.innerHeight - BANNER_HEIGHT - PADDING * 2;
    //   this.maxSize = offsetHeihgt - ETC;
    // }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.appointAccordDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
  .page-wrap {
    padding-top: 10px;
  }
}
</style>
<style lang="less">
.appointAccordDiv {
  .el-radio-button--small .el-radio-button__inner {
    font-size: 14px;
  }
}
</style>
